import React, { Component, Fragment } from "react";
import styled from "@emotion/styled";
import Sticky from "Components/Sticky/index";
import styles from "./EXIMCargoTracking.module.scss";
import { ReactComponent as FilterIcon } from 'Icons/filter.svg';
import {
  PageWrapperT2,
  PageWrapperT4,
} from "Components/Common/Wrapper/PageWrapper";
import {
  HeaderSection,
  TabButtonSection,
  ShipmentFileUploadAndDownloadSection,
  InprogressAndCompletedFilterBox,
  ShipmentDetailsTable,
  InprogressAndCompletedTable,
  ModalCardT2,
  RoutesDetailsTable,
  EventStatusTable
} from "Components/EXIMCargoTracking/Index";
import { Spacer } from "Components/Common/Spacer/index";
import {
  GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
  GET_EXIM_CARGO_TEMPLATE,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,
  GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
  TOAST_ERROR,
  UPLOAD_EXIM_CARGO_TEMPLATE,
  POST_ON_DEMAND_TRACKING,
  SAVE_EXIM_CONTAINER_SKU_DETAILS
} from "Constants/actionConstants";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import ActionBlurLoader from "Components/ActionLoader/LoaderWithBlur";
import ModalT1 from "Components/Common/Modal/ModalT1";
import ModalCardT1 from "Components/RateComparison/CalculationForFreight/ModalCardT1";
import ModalCardT3 from "Components/EXIMCargoTracking/ModalCardT3";
import AdditionalFilesDetailsCard from "Components/EXIMCargoTracking/AdditionalFilesDetailsCard";
import InlandTrackingTable from "Components/EXIMCargoTracking/InlandTrackingTable";
import { ReactComponent as DownloadIconT1 } from "Icons/downloadIconT1.svg";
import {
  ButtonT2,
  ButtonT7,
} from "Components/Common/Button/index";
import DownloadEximTrackingConfirmationPopup from "Components/EXIMCargoTracking/DownloadEximTrackingConfirmationPopup";
import ModalT2 from "Components/Common/Modal/ModalT2.";
import UploadEximTrackingConfirmationPopup from "Components/EXIMCargoTracking/UploadEximTrackingConfirmationPopup";
import RenderPaginationButtons from "Components/EXIMCargoTracking/pagination";

class EXIMCargoTracking extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedShipment: "seaShipment",
      selectedTab: 1, // for identification purposes only
      eximCargoTemplateFile: null,
      eximCargoTemplateFileName: "",
      isModalPopupOpen: false,
      selectItemForMoreInformationPopup: {},
      selectItemForAdditionalFilesDetails: {},
      selectItemForEventDetails: {},
      modalType: 1, // for identification purposes only
      filter: {
        source: null,
        destination: null,
        status: null,
        from: null,
        to: null,
      },
      offset: 0,
      limit: 10,
      isRenderFilterBox:false,
      fromDate:null,
      toDate:null,
      downloadFrom:null,
      downloadTo:null,
      selectedDownloadOption:null,
      downloadFileUrl: null,
      selectedUploadOption:null,
    };
  }

  componentDidMount() {
    // this.handleGetEximCargoTemplate();
    this.handleGetEximContainerBlTrackingDetails();
    this.handleGetEximCargoSourceDestinationPortListAndStatusList();
    // this.handleGetEximContainerBlTrackingDetailsTemplate();
  }

  componentDidUpdate(prevProps, prevState) {
    const { selectedTab, filter } = this.state;

    if (prevState.selectedTab !== selectedTab || prevState.filter !== filter) {
      // this.setState({
      //   filter: {
      //     ...filter,
      //     status: null,
      //   },
      // });
      this.handleGetEximContainerBlTrackingDetails();
    }
  }

  handleGetEximCargoSourceDestinationPortListAndStatusList = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_EXIM_CARGO_SOURCE_DESTINATION_PORT_AND_STATUS,
    });
  };
  handleGetEximCargoTemplate = () => {
    const { dispatch } = this.props;
    dispatch({
      type: GET_EXIM_CARGO_TEMPLATE,
      onSuccess: (data) => {
        this.handleDownloadEximCargoTemplateFile(data);
      }
    });
  };
  handleGetEximContainerBlTrackingDetailsTemplate = (
    isContainerNumberWise = false,
    containerNumber
  ) => {
    const { dispatch } = this.props;
    const onSuccessContainerNumberWise = (url) => {
      this.handleDownloadEximContainerBlTrackingDetailsTemplateFile(url);
    };
    dispatch({
      type: GET_EXIM_CONTAINER_BL_TRACKING_DETAILS_TEMPLATE,
      payload: {
        isContainerNumberWise,
        onSuccessContainerNumberWise,
        queryParams: {
          containerNumber,
        },
      },
    });
  };

  handleOnClickDownloadContainerBlTrackingFile = (containerNumber) => {
    this.handleGetEximContainerBlTrackingDetailsTemplate(true, containerNumber);
  };

  handleGetEximContainerBlTrackingDetails = () => {
    const { dispatch } = this.props;
    const { selectedTab, filter, limit, offset } = this.state;
    const updateFilter = {
      status: !!filter.status && selectedTab === 2 ? filter.status.value : null,
      source: !!filter.source ? filter.source.value : null,
      destination: !!filter.destination ? filter.destination.value : null,
      // from: !!filter.from ? filter.from.value : null,
      // to: !!filter.to ? filter.to.value : null,
      from: this.state.fromDate?new Date(this.state.fromDate).getTime() : null,
      to: this.state.toDate?new Date(this.state.toDate).getTime() : null,
      containerNumber: filter.containerNumber || null,
      blNumber: !!filter.blNumber ? filter.blNumber.value : null,
      categoryName: !!filter.categoryName ? filter.categoryName.value : null,
      limit,
      offset
    };
    dispatch({
      type: GET_EXIM_CONTAINER_BL_TRACKING_DETAILS,
      queryParams: {
        type: selectedTab === 4 ? 3 : selectedTab,
        ...updateFilter,
      },
    });
  };
  handleOnClickBack = () => {
    const { history } = this.props;
    history.goBack();
  };

  handleOnClickSelectedTab = (selectedTab) => {
    this.setState({ 
      selectedTab,
      isRenderFilterBox:false,
      fromDate:null,
      toDate:null,
     });
  };
  handleDownloadEximCargoTemplateFile = (eximCargoTemplateFileUrl) => {
    // const { eximCargoTemplateFileUrl } = this.props;
    const link = document.createElement("a");
    link.href = eximCargoTemplateFileUrl;
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handleDownloadEximContainerBlTrackingDetailsTemplateFile = (url) => {
    const { eximContainerBlTrackingDetailsTemplateFileUrl } = this.props;
    const link = document.createElement("a");
    link.href = !!url ? url : eximContainerBlTrackingDetailsTemplateFileUrl;
    link.setAttribute("download", true);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  handleOnChangeForEximCargoTemplateFile = (event) => {
    const eximCargoTemplateFile = event.target.files[0];
    const eximCargoTemplateFileName = eximCargoTemplateFile.name;
    this.setState({ eximCargoTemplateFile, eximCargoTemplateFileName });
  };
  handleOnClickUploadForEximCargoTemplateFile = () => {
    const { eximCargoTemplateFile } = this.state;
    const { dispatch } = this.props;
    const formData = new FormData();
    if (eximCargoTemplateFile !== null) {
      const onSuccess = () => {
        this.handleGetEximContainerBlTrackingDetails();
      };
      formData.append("file", eximCargoTemplateFile);
      dispatch({
        type: UPLOAD_EXIM_CARGO_TEMPLATE,
        payload: formData,
        onSuccess,
      });
    } else {
      dispatch({
        type: TOAST_ERROR,
        message: "Please Upload File",
      });
    }
  };

  handleModalPopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalT2PopupOpen = () => {
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalT2PopupOpen: true,
      };
      return updatepreviousState;
    });
  };

  handleModalPopupClose = () => {
    const {modalType}=this.state;
    if(modalType === 2){
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          selectItemForAdditionalFilesDetails: {},
        };
        return updatepreviousState;
      },()=>{
        this.handleGetEximContainerBlTrackingDetails()
      });
    }
    this.setState((previousState) => {
      let updatepreviousState = {
        ...previousState,
        isModalPopupOpen: false,
      };
      return updatepreviousState;
    });
  };

  handleModalT2PopupClose = () => {
    const { modalType }=this.state;
    if(modalType === 77){
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          isModalT2PopupOpen: false,
          downloadFrom:null,
          downloadTo:null,
          selectedDownloadOption:null,
          downloadFileUrl:null,
        };
        return updatepreviousState;
      });
    }
    else if(modalType === 78){
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,
          selectedUploadOption:null,
          isModalT2PopupOpen: false,
        };
        return updatepreviousState;
      });
    }
    else{
      this.setState((previousState) => {
        let updatepreviousState = {
          ...previousState,

          isModalT2PopupOpen: false,
        };
        return updatepreviousState;
      });
    }
  };

  handleOnclickForMoreInformationPopup = (data) => {
    this.setState(
      { selectItemForMoreInformationPopup: data, modalType: 1 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  };
  handleOnClickAdditionalFiles = (data) => {
    this.setState(
      { selectItemForAdditionalFilesDetails: data, modalType: 2 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  };
  handleFilterBoxOnChange = (data, name) => {
    const { filter } = this.state;
    const updateFilter = {
      ...filter,
      [name]: data,
    };
    this.setState({ filter: updateFilter, offset: 0 });
  };

  handleOnclickEventStatusInformationPopup = (data) => {
    this.setState(
      { selectItemForEventDetails: data, modalType: 3 },
      () => {
        this.handleModalPopupOpen();
      }
    );
  }

  goToPage = (pageNumber) => {
    const { limit } = this.state; 
    const newOffset = (pageNumber - 1) * limit;
    this.setState({
        offset: newOffset,
    }, () => {
      this.handleGetEximContainerBlTrackingDetails();
    });
   
}

handleOnClickOnDemandTracking = (containerNo) => {
  const { dispatch } = this.props;
  dispatch({
    type: POST_ON_DEMAND_TRACKING,
    payload: {
      container_number: containerNo
    },
    onSuccess: () => {
      this.handleGetEximContainerBlTrackingDetails();
    }
  });
}
renderTheFiltersSectionforIntransitandCompleted=()=>{
  const {isRenderFilterBox}=this.state;
    this.setState({
      isRenderFilterBox:!isRenderFilterBox
    })
}

onDatesChange = (startDate, endDate) => {
  this.setState({
    fromDate:startDate,
    toDate:endDate
  },()=>{
    this.handleGetEximContainerBlTrackingDetails();
  });
}
onDateFocusChange=(focusedInput)=>{
  this.setState({ focusedInput: true ? focusedInput : null },()=>{

  })
}

handleOnClickDownload=()=>{
this.setState({
  modalType:77
},() => {
  this.handleModalT2PopupOpen();
})}

handleOnClickUpoad=()=>{
  this.setState({
    modalType:78
  },() => {
    this.handleModalT2PopupOpen();
  })}

  handleDownloadDatesChange = ({ startDate, endDate }) => {
    this.setState({ downloadFrom: startDate, downloadTo: endDate });
  };

  handleDownloadSelectChange = (selectedOption) => {
    this.setState({ selectedDownloadOption:selectedOption });
  };
  handleUploadSelectChange = (selectedOption) => {
    this.setState({ selectedUploadOption:selectedOption });
  };
  handleDownloadFile = () => {
    const { dispatch, match } = this.props;
    dispatch({
      type: GET_EXIM_CARGO_TEMPLATE,
      data: {
        type: this.state.selectedDownloadOption.value,
        status:this.state.selectedTab,
        from:new Date(this.state.downloadFrom).getTime(),
        to:new Date(this.state.downloadTo).getTime(),
      },
      onSuccess: (responseLink) => {
        this.setState({
          downloadFileUrl: responseLink
        }, () => {
          document.getElementById('SFTPfile').click();
        })
      },
    });
  }

  handleUploadFile=(file)=>{
    const { dispatch } = this.props;
    const formData = new FormData();
    formData.append("file", file);
    formData.append("type", this.state.selectedUploadOption.value);
    formData.append("status",this.state.selectedTab)
            dispatch({
                type: UPLOAD_EXIM_CARGO_TEMPLATE,
                file,
                payload: formData,
                onSuccess: () => {
                  this.handleGetEximContainerBlTrackingDetails();
                }
            });
  }
  onSaveAdditionalDetailsSkuDetails = (skuDetails=[],exim_cargo_id='') => {
    const { dispatch } = this.props;
    // Remove 'id' key from each object
    const cleanedSkuDetails = skuDetails.map(({ id, ...rest }) => rest);

    dispatch({
      type: SAVE_EXIM_CONTAINER_SKU_DETAILS,
      payload: {
        sku_details: cleanedSkuDetails,
        exim_cargo_id:exim_cargo_id,
      },
      onSuccess: () => {
        this.handleGetEximContainerBlTrackingDetails();
      }
    });
  }
  onSaveAdditionalDetailsInvoiceDetails = (invoiceDetails=[],exim_cargo_id='') => {
    const { dispatch } = this.props;
    // Remove 'id' key from each object
    const cleanedinvoiceDetails = invoiceDetails.map(({ id, ...rest }) => rest);

    dispatch({
      type: SAVE_EXIM_CONTAINER_SKU_DETAILS,
      payload: {
        invoice_details: cleanedinvoiceDetails,
        exim_cargo_id:exim_cargo_id,
      },
      onSuccess: () => {
        this.handleGetEximContainerBlTrackingDetails();
      }
    });
  }

  render() {
    const {
      selectedShipment,
      selectedTab,
      eximCargoTemplateFileName,
      isModalPopupOpen,
      isModalT2PopupOpen,
      selectItemForMoreInformationPopup,
      modalType,
      selectItemForAdditionalFilesDetails,
      filter,
      selectItemForEventDetails,
      fromDate,
      toDate
    } = this.state;

    const {
      loaderT1,
      uploadShipmentDetailsList,
      sourcePortList,
      destinationPortList,
      statusList,
      inprogressShipmentDetailsList,
      completedShipmentDetailsList,
      blNumbers,
      trackingCount,
      categoryList
    } = this.props;
    return (
      <Fragment>
        {loaderT1 && <ActionBlurLoader fixed={true} />}
        <div className="navBarWrapper">
          <Sticky></Sticky>
        </div>

        <ModalT1
          isOpenState={isModalPopupOpen}
          handleOnClickForClose={this.handleModalPopupClose}
        >
          {modalType === 1 && (
            <ModalCardT2
              selectItemForMoreInformationPopup={
                selectItemForMoreInformationPopup
              }
            >
              <RoutesDetailsTable
                selectItemForMoreInformationPopup={
                  selectItemForMoreInformationPopup
                }
              />
            </ModalCardT2>
          )}

          {modalType === 2 && (
            <ModalCardT3 title={"Additional Files"}>
              <AdditionalFilesDetailsCard
                data={selectItemForAdditionalFilesDetails}
                onSaveAdditionalDetailsSkuDetails={this.onSaveAdditionalDetailsSkuDetails}
                onSaveAdditionalDetailsInvoiceDetails={this.onSaveAdditionalDetailsInvoiceDetails}
              />
            </ModalCardT3>
          )}
          
          {modalType === 3 && (
            <ModalCardT2
            selectItemForMoreInformationPopup={
                selectItemForEventDetails
              }
              modalType={modalType}
            >
              <EventStatusTable
                data={
                  selectItemForEventDetails
                }
              />
            </ModalCardT2>
          )

          }
          
        </ModalT1>
        <ModalT2
          isOpenState={isModalT2PopupOpen}
          handleOnClickForClose={this.handleModalT2PopupClose}
        >
          {modalType === 77 && 
            (
              <ModalCardT3
                title={"Download "}
              >
                <DownloadEximTrackingConfirmationPopup
                  downloadFrom={this.state.downloadFrom}
                  downloadTo={this.state.downloadTo}
                  handleDownloadDatesChange={this.handleDownloadDatesChange}
                  selectedDownloadOption={this.state.selectedDownloadOption}
                  handleDownloadSelectChange={this.handleDownloadSelectChange}
                  handleDownloadFile={this.handleDownloadFile}
                  downloadFileUrl={this.state.downloadFileUrl}
                />
                </ModalCardT3>
          )
          }
          {
            modalType === 78 && 
            (
              <ModalCardT3
                title={"Upload"}
              >
                <UploadEximTrackingConfirmationPopup
                  selectedUploadOption={this.state.selectedUploadOption}
                  handleUploadSelectChange={this.handleUploadSelectChange}
                  handleUploadFile={this.handleUploadFile}
                />
              </ModalCardT3>
            )
          }
        </ModalT2>

        <PageWrapperT4>
          <HeaderSection handleOnClickBack={this.handleOnClickBack} />
          <Spacer spacing={"10px"} />
          <TabButtonSection
            handleOnClickSelectedTab={this.handleOnClickSelectedTab}
            selectedTab={selectedTab}
          />
          <Spacer spacing={"10px"} />
          {selectedTab === 1 && (
            <ShipmentFileUploadAndDownloadSection
              handleDownloadEximCargoTemplateFile={
                this.handleGetEximCargoTemplate
              }
              handleOnChangeForEximCargoTemplateFile={
                this.handleOnChangeForEximCargoTemplateFile
              }
              eximCargoTemplateFileName={eximCargoTemplateFileName}
              handleOnClickUploadForEximCargoTemplateFile={
                this.handleOnClickUploadForEximCargoTemplateFile
              }
            />
          )}
          {(selectedTab === 2 || selectedTab === 3 || selectedTab === 4) && 
          <div className='flex flex-middle gap-10'>
            <ButtonT2 
              onClick={()=>{
              this.handleOnClickDownload()
              }}>
              <DownloadIconT1 />
              Download
            </ButtonT2>
            <ButtonT7 
            onClick={()=>{
              this.handleOnClickUpoad()
            }}>
              Upload
            </ButtonT7>

            
              <button
                className="ht-40 br-5 theme-color border-theme fs-16 fBold pl-10 pr-10 flex flex-middle"
                onClick={()=>{
                  this.renderTheFiltersSectionforIntransitandCompleted()
                }}
              >
                <FilterIcon />
              </button>
          </div>
          }
          <RenderPaginationButtons
            totalCount={trackingCount}
            goToPage={this.goToPage}
            offset={this.state.offset}
            limit={this.state.limit}
          />
          {!!this.state.isRenderFilterBox && (
            <InprogressAndCompletedFilterBox
              selectedTab={selectedTab}
              sourcePortList={sourcePortList}
              destinationPortList={destinationPortList}
              statusList={statusList}
              handleDownloadEximContainerBlTrackingDetailsTemplateFile={
                this.handleDownloadEximContainerBlTrackingDetailsTemplateFile
              }
              handleFilterBoxOnChange={this.handleFilterBoxOnChange}
              filter={filter}
              blNumbers={blNumbers}
              trackingCount={trackingCount}
              goToPage={this.goToPage}
              offset={this.state.offset}
              limit={this.state.limit}
              categoryList={categoryList}
              fromDate={this.state.fromDate}
              toDate={this.state.toDate}
              onDatesChange={this.onDatesChange}
              focusedInput={this.state.focusedInput}
              onDateFocusChange={this.onDateFocusChange}
            />
          )}
          <Spacer spacing={"10px"} />
          {selectedTab === 1 && (
            <ShipmentDetailsTable
              uploadShipmentDetailsList={uploadShipmentDetailsList}
            />
          )}
          {(selectedTab === 2 || selectedTab === 3) && (
            <InprogressAndCompletedTable
              selectedTab={selectedTab}
              inprogressShipmentDetailsList={inprogressShipmentDetailsList}
              completedShipmentDetailsList={completedShipmentDetailsList}
              handleOnclickForMoreInformationPopup={
                this.handleOnclickForMoreInformationPopup
              }
              handleOnClickDownloadContainerBlTrackingFile={
                this.handleOnClickDownloadContainerBlTrackingFile
              }
              handleOnClickAdditionalFiles={this.handleOnClickAdditionalFiles}
              handleOnclickEventStatusInformationPopup={this.handleOnclickEventStatusInformationPopup}
              handleOnClickOnDemandTracking={this.handleOnClickOnDemandTracking}
            />
          )}
          {/* {(selectedTab === 4) &&
            (<InlandTrackingTable
              selectedTab={selectedTab}
              completedShipmentDetailsList={completedShipmentDetailsList}
              handleOnclickEventStatusInformationPopup={this.handleOnclickEventStatusInformationPopup}
            />)
          } */}
        </PageWrapperT4>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  console.log("state:", state);
  return {
    loaderT1: !!state.common.loaderT1,
    eximCargoTemplateFileUrl: state.EXIMCargoTracking.eximCargoTemplateFileUrl,
    eximContainerBlTrackingDetailsTemplateFileUrl:
      state.EXIMCargoTracking.eximContainerBlTrackingDetailsTemplateFileUrl,
    uploadShipmentDetailsList:
      state.EXIMCargoTracking.uploadShipmentDetailsList,
    inprogressShipmentDetailsList:
      state.EXIMCargoTracking.inprogressShipmentDetailsList,
    completedShipmentDetailsList:
      state.EXIMCargoTracking.completedShipmentDetailsList,
    sourcePortList: state.EXIMCargoTracking.sourcePortList,
    destinationPortList: state.EXIMCargoTracking.destinationPortList,
    statusList: state.EXIMCargoTracking.statusList,
    blNumbers: state.EXIMCargoTracking.blNumbers,
    trackingCount: state.EXIMCargoTracking.trackingCount,
    categoryList: state.EXIMCargoTracking.categoryList
  };
};

export default connect(mapStateToProps)(withRouter(EXIMCargoTracking));
